require("./bootstrap");

import Vue from "vue";
import VueRouter from "vue-router";

import router from "./Router/index";
import store from "./Store/index";
import App from "./App.vue";

import VueAxios from "vue-axios";
import axios from "axios";

// axios.defaults.withCredentials = true;

import UniversalSocialauth from "universal-social-auth";

const options = {
    providers: {
        google: {
            clientId: window.config.googleId,
            redirectUri: window.location.origin + "/social/google",
        },
        facebook: {
            clientId: window.config.facebookId,
            redirectUri: window.location.origin + "/social/facebook",
        },
    },
};

const Oauth = new UniversalSocialauth(axios, options);

Vue.prototype.$axios = axios;
Vue.prototype.$Oauth = Oauth;

Vue.use(VueRouter);

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!store.state.auth.authenticated) {
            next({
                name: "home",
                // query: { redirect: to.fullPath }
            });
        } else {
            next();
        }
    } else {
        next(); // make sure to always call next()!
    }
});

import {
    LinkPlugin,
    ButtonPlugin,
    ModalPlugin,
    LayoutPlugin,
    TooltipPlugin,
    FormGroupPlugin,
    FormInputPlugin,
    FormSelectPlugin,
    FormTextareaPlugin,
    ListGroupPlugin,
    FormCheckboxPlugin,
    ImagePlugin,
    DropdownPlugin,
    BadgePlugin,
    NavbarPlugin,
    PaginationPlugin,
    CollapsePlugin,
    SpinnerPlugin,
    CardPlugin,
    TablePlugin,
    ToastPlugin,
    EmbedPlugin,
    BIcon,
    BIconPencil,
    BIconXCircleFill,
    BIconXCircle,
    BIconQuestion,
    BIconArrowClockwise,
    BIconPlus,
    BIconPerson,
    BIconList,
    BIconCaretDown,
    BIconCaretUp,
    BIconTrash,
    BIconGeoAltFill,
    BIconExclamationCircle,
    BIconClockHistory,
    BIconCheckCircle,
    BIconMic,
    BIconStopFill,
    BIconFacebook,
    BIconTwitter,
    BIconChatLeftText,
    BIconVolumeUp,
    BIconChatLeft,
    BIconstack,
    BIconArrowLeftCircle,
} from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(LinkPlugin);
Vue.use(ButtonPlugin);
Vue.use(ModalPlugin);
Vue.use(LayoutPlugin);
Vue.use(TooltipPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(ImagePlugin);
Vue.use(DropdownPlugin);
Vue.use(NavbarPlugin);
Vue.use(PaginationPlugin);
Vue.use(CollapsePlugin);
Vue.use(CardPlugin);
Vue.use(SpinnerPlugin);
Vue.use(TablePlugin);
Vue.use(ToastPlugin);
Vue.use(EmbedPlugin);
Vue.use(ListGroupPlugin);
Vue.use(BadgePlugin);

Vue.component("BIcon", BIcon);
Vue.component("BIconPencil", BIconPencil);
Vue.component("BIconXCircleFill", BIconXCircleFill);
Vue.component("BIconXCircle", BIconXCircle);
Vue.component("BIconQuestion", BIconQuestion);
Vue.component("BIconArrowClockwise", BIconArrowClockwise);
Vue.component("BIconPlus", BIconPlus);
Vue.component("BIconPlus", BIconPlus);
Vue.component("BIconPerson", BIconPerson);
Vue.component("BIconList", BIconList);
Vue.component("BIconCaretDown", BIconCaretDown);
Vue.component("BIconCaretUp", BIconCaretUp);
Vue.component("BIconTrash", BIconTrash);
Vue.component("BIconGeoAltFill", BIconGeoAltFill);
Vue.component("BIconExclamationCircle", BIconExclamationCircle);
Vue.component("BIconClockHistory", BIconClockHistory);
Vue.component("BIconCheckCircle", BIconCheckCircle);
Vue.component("BIconMic", BIconMic);
Vue.component("BIconStopFill", BIconStopFill);
Vue.component("BIconFacebook", BIconFacebook);
Vue.component("BIconTwitter", BIconTwitter);
Vue.component("BIconChatLeftText", BIconChatLeftText);
Vue.component("BIconVolumeUp", BIconVolumeUp);
Vue.component("BIconChatLeft", BIconChatLeft);
Vue.component("BIconstack", BIconstack);
Vue.component("BIconArrowLeftCircle", BIconArrowLeftCircle);

import PortalVue from "portal-vue";

Vue.prototype.$eventBus = new Vue();

Vue.use(PortalVue);

import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import VueSocialSharing from "vue-social-sharing";

Vue.use(VueSocialSharing);

store.dispatch("auth/me").then(() => {
    const app = new Vue({
        el: "#app",
        router,
        store,
        components: { App },
    });
});
